import React, { Fragment } from "react";

import Button from "../shared/Button";

const AccountWelcomeModal = props => (
  <Fragment>
    <div className="modal__header">
      <span>{props.t("modals:welcomeModelTitle")}</span>
    </div>

    <div className="modal__body">
      <div className="modal__close" onClick={props.handleCloseModal}>
        <svg className="bars-icon" viewBox="0 0 24 24">
          <path d="M1,1 L22,22 M1,22 L22,1" stroke="#000" strokeWidth="1" />
        </svg>
      </div>
      <div className="pv4 f4 tc ph7">
        <div className="pb3">
          {props.t("modals:welcomeModelText1")}
        </div>
        <div>
          {props.t("modals:welcomeModelText2")}
        </div>
        <div className="tc mt6">
          <Button
            label={props.t("common:continueButton")}
            icon="i-arrow-right f6"
            onClick={props.updateUserHasVisited}
          />
        </div>
      </div>
    </div>
  </Fragment>
);

export default AccountWelcomeModal;



// WEBPACK FOOTER //
// ./src/components/modals/AccountWelcomeModal.js